import { AdminRole, TournamentAdmin } from '../../domain/models';

export interface TournamentAdminEntity {
  id: string;
  tournament_id: string;
  user_id: string;
  role: string;
  created_at: string;
}

// Mapper: de Entity (DB) a Model (Domain)
export const tournamentAdminEntityToModel = (entity: TournamentAdminEntity, userEmail?: string, userName?: string): TournamentAdmin => {
  return {
    id: entity.id,
    tournamentId: entity.tournament_id,
    userId: entity.user_id,
    role: entity.role as AdminRole,
    userEmail,
    userName,
    createdAt: new Date(entity.created_at),
  };
};

// Mapper: de Model (Domain) a Entity (DB)
export const tournamentAdminModelToEntity = (model: Partial<TournamentAdmin>): Partial<TournamentAdminEntity> => {
  return {
    ...(model.tournamentId !== undefined && { tournament_id: model.tournamentId }),
    ...(model.userId !== undefined && { user_id: model.userId }),
    ...(model.role !== undefined && { role: model.role }),
  };
};